import { downloadBlob } from "@/lib/downloadBlob";

// CSV com ";" (padrão do Excel pt-BR). Campos com separador, aspas ou quebra de linha vão entre aspas.
// Texto que o Excel leria como fórmula (=, +, -, @, tab, CR no início) ganha um apóstrofo na frente:
// descrições de rubrica vêm dos arquivos do cliente (CSV injection).
function celula(valor: string | number | null | undefined): string {
  const bruto = valor == null ? "" : String(valor);
  const texto = typeof valor === "string" && /^[=+\-@\t\r]/.test(bruto) ? `'${bruto}` : bruto;
  return /[";\n\r]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
}

export function gerarCsv(cabecalho: string[], linhas: (string | number | null | undefined)[][]) {
  return [cabecalho, ...linhas].map((linha) => linha.map(celula).join(";")).join("\r\n");
}

/** BOM na frente para o Excel abrir acentos em UTF-8. */
export function exportarCsv(
  nomeArquivo: string,
  cabecalho: string[],
  linhas: (string | number | null | undefined)[][],
): void {
  downloadBlob(`\uFEFF${gerarCsv(cabecalho, linhas)}`, nomeArquivo);
}
